export const TABLE_CONTAINER =
    'overflow-hidden rounded-2xl border border-raro-gray-200 bg-white shadow-sm';

export const TABLE_SCROLL = 'overflow-x-auto';

export const TABLE_MOBILE_MEDIA_QUERY = '(max-width: 1023px)';

export const TABLE = 'min-w-[1260px] w-full table-fixed text-sm font-montserrat';

export const TABLE_COMPACT = 'min-w-[720px] w-full table-fixed text-sm font-montserrat';

export const THEAD = 'border-b border-raro-gray-200 bg-raro-surface-50';

export const TH =
    'whitespace-nowrap border-r border-raro-gray-200 px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-raro-gray-500 last:border-r-0';

export const TH_STICKY = 'sticky top-0 z-10 bg-raro-surface-50';

export const TH_SORTABLE =
    'cursor-pointer select-none transition-colors hover:text-raro-gray-800';

export const TD_PINNED_LEFT = 'sticky z-10 bg-white';

export const TH_PINNED_LEFT = 'sticky bg-raro-surface-50';

export const TR = 'border-b border-raro-gray-100 transition-colors last:border-0 hover:bg-raro-surface-50';

export const TD =
    'border-r border-raro-gray-100 px-4 py-3 align-middle text-raro-gray-800 last:border-r-0';

export const TD_RIGHT = `${TD} text-right`;

export const TD_NUMERIC = `${TD} text-right tabular-nums font-medium text-raro-gray-900`;

export const EMPTY_BOX =
    'rounded-2xl border border-dashed border-raro-gray-300 bg-white p-10 text-center';

export const LOADING_BOX =
    'rounded-2xl border border-raro-gray-200 bg-white p-10 text-center text-sm text-raro-gray-500 font-montserrat';
